import { buildEqFilter } from '@/ui/composites/grid/gridFilters';
import { resolveSuiteRunTestCounts } from './suiteRuns.testCounts';
import type { TableV2Counts } from '@/features/shared/components/tableSystem/TableV2Primitives';
import type { ApiSort, GridQueryInput } from '@/ui/composites/grid/gridUtils';
import type { SuiteListItemDto, SuiteRunDto } from '@flowqa/shared';

export const defaultSuiteV2Sort = {
  field: 'latestRunTimestamp',
  direction: 'desc',
} satisfies ApiSort;

export const defaultNestedSuiteRunSort = {
  field: 'timestamp',
  direction: 'desc',
} satisfies ApiSort;

export const countSuiteRunTests = (row: SuiteRunDto): TableV2Counts => {
  const counts = resolveSuiteRunTestCounts(row);
  const total = counts.passed + counts.failed + counts.errored + counts.skipped + counts.untested;
  return { total, ...counts };
};

export const resolveSuiteRunChildCount = (
  row: Pick<SuiteListItemDto, 'executionStatusCounts' | 'executionSummaries'>,
): number => row.executionStatusCounts?.total ?? row.executionSummaries?.length ?? 0;

export const buildNestedSuiteRunFilters = ({
  latestOnly,
  latestRunId,
  suiteId,
}: {
  latestOnly: boolean;
  latestRunId: string | null;
  suiteId: string;
}): GridQueryInput['filters'] =>
  latestOnly && latestRunId !== null
    ? buildEqFilter('id', latestRunId)
    : buildEqFilter('suiteId', suiteId);
